import { render, staticRenderFns } from "./ItemDropzone.vue?vue&type=template&id=3e428849&scoped=true&"
import script from "./ItemDropzone.vue?vue&type=script&lang=ts&"
export * from "./ItemDropzone.vue?vue&type=script&lang=ts&"
import style0 from "./ItemDropzone.vue?vue&type=style&index=0&id=3e428849&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e428849",
  null
  
)

export default component.exports